import AppBarAdmin from "../../components/AppBarAdmin";
import Table from "../../components/Table";
import { createMaterial, deleteMaterial, getMateriais, updateMaterial } from "../../services/materiaisService";

export default function Materiais() {
    return (
        <>
            <AppBarAdmin title="Materiais" />
            <Table 
                loadData={getMateriais} 
                createItem={createMaterial}
                updateItem={updateMaterial}
                deleteItem={deleteMaterial}
                titulo="Materiais" 
            />
        </>
    )
}